const retryReducer = (initialState = {}, action) => {
  switch (action.type) {
    case 'INCREMENT_RETRY': {
      return { retries: action.retry };
    }
    case 'CLEAR_RETRY': {
      return { retries: 0 };
    }
    default:
      return initialState;
  }
};

export default retryReducer;
